export default function Form({ title, children, ...params }) {
  return (
    <div {...params}>
      {title && (
        <div className="Form--header">
          <h2 className="Form--title">{title}</h2>
        </div>
      )}
      <div className="">{children}</div>
    </div>
  );
}
